import {
  FETCH_ADLIST_REQUEST,
  FETCH_ADLIST_SUCCESS,
  FETCH_ADLIST_FAIL,
  CREATE_AD_REQUEST,
  CREATE_AD_SUCCESS,
  CREATE_AD_FAIL,
  UPDATE_AD_REQUEST,
  UPDATE_AD_SUCCESS,
  UPDATE_AD_FAIL,
  DELETE_AD_REQUEST,
  DELETE_AD_SUCCESS,
  DELETE_AD_FAIL,
} from '../../store/types';

const initialState = {
  loading: false,
  error: null,
  ads: [],
  total: 0,
  page: 1,
  pageSize: 20,
  selectedAd: null,
};

const adReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ADLIST_REQUEST:
    case CREATE_AD_REQUEST:
    case UPDATE_AD_REQUEST:
    case DELETE_AD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_ADLIST_SUCCESS:
      return {
        ...state,
        loading: false,
        ads: action.payload.items,
        total: action.payload.total,
        page: action.payload.page,
        pageSize: action.payload.pageSize,
        error: null,
      };

    case CREATE_AD_SUCCESS:
      return {
        ...state,
        loading: false,
        ads: [...state.ads, action.payload],
        error: null,
      };

    case UPDATE_AD_SUCCESS:
      return {
        ...state,
        loading: false,
        ads: state.ads.map((ad) => (ad.id === action.payload.id ? action.payload : ad)),
        error: null,
      };

    case DELETE_AD_SUCCESS:
      return {
        ...state,
        loading: false,
        ads: state.ads.filter((ad) => ad.id !== action.payload),
        error: null,
      };

    case FETCH_ADLIST_FAIL:
    case CREATE_AD_FAIL:
    case UPDATE_AD_FAIL:
    case DELETE_AD_FAIL:
      return {
        ...state,
        loading: false,
        // action.payload is a ContractError: { code, message, requestId }
        error: action.payload,
      };

    default:
      return state;
  }
};

export default adReducer;
